import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    save: (count: number) => translate({ id: 'orders.edit.bulk.save', values: { count } }),
    cancel: translate({ id: 'global.cancel' }),
  }))

  return api
}
